<script setup>
const { model } = defineProps(['model'])

const route = useRoute()
const router = useRouter()
const pageNumber = computed(() => {
  const page = Number(route.query.page)
  return Number.isNaN(page) || page < 1 ? 1 : page
})

function onPageChange(newPage) {
  router.push({ query: { ...route.query, page: newPage } })
}

const { data } = await useAsyncData(
  () => `testimonials-${pageNumber.value}`,
  async () => {
    const response = await $fetch('/api/testimonials/getTestimonials', {
      method: 'GET',
      query: {
        pageNumber: pageNumber.value,
      },
    })

    return {
      testimonials: response.testimonials?.filter(Boolean).map(testimonial => ({
        contentLink: { id: testimonial.contentId },
        aprimoMainImage: {
          url: testimonial.imageUrl,
        },
        aprimoMainImageAltText: {
          value: testimonial.imageAltText || testimonial.authorName || 'Testimonial',
        },
        testimonialName: { value: testimonial.testimonialName },
        authorName: { value: testimonial.authorName },
        description: { value: testimonial.pageSummary },
        quote: { value: testimonial.quote },
        pageUrl: { value: testimonial.pageUrl },
      })) || [],
      title: { value: model.pageTitle?.value },
      body: { value: model.pageBody?.value },
      testimonialCount: response.testimonialCount,
    }
  },
)
</script>

<template>
  <div class="testimonial-feed-page mb-20">
    <template v-if="model.pageHeroContent?.heroStyle?.value">
      <HeroBlock
        :variation="model.pageHeroContent?.heroStyle?.value"
        :title="model.pageHeroContent?.heroTitle?.value"
        :description="model.pageHeroContent?.heroDescription?.value"
        :color="model.pageHeroContent?.heroColor?.value"
        :image="model.pageHeroContent?.aprimoHeroImage?.url || '/images/hero-basic.jpg'"
        :image-alt-text="model.pageHeroContent?.heroImageAltText?.value || 'Hero Image'"
        :image-width="model.pageHeroContent?.aprimoHeroImage?.width"
        :image-height="model.pageHeroContent?.aprimoHeroImage?.height"
        :body="model.pageHeroContent?.heroBody?.value"
      />
    </template>

    <TestimonialBlock
      :model="model.featuredTestimonial?.expandedValue"
    />

    <TestimonialListingBlock
      v-if="data"
      variation="two-col"
      :model="data"
    >
      <template #pagination>
        <PaginationBlock
          v-if="data?.testimonialCount && data.testimonialCount > 1"
          :total="data.testimonialCount"
          :items-per-page="8"
          :on-page-change="onPageChange"
          :current-page="pageNumber"
          pagination-class="m-auto mt-10"
        />
      </template>
    </TestimonialListingBlock>
    <div class="container-fluid">
      <div class="page-block-area flex flex-col items-center w-full">
        <GenericsContentArea
          v-if="model.pageBlockArea?.expandedValue"
          :model="model.pageBlockArea.expandedValue"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/pages/testimonial-feed-page.scss';
</style>
